/*
  TSC — description accordion
  Turns every product description into collapsible sections, one per heading
  (h2 / h3 / h4) found in the description. Works for all present and future
  products with no per-product editing.

  - Heading row: left aligned, plus icon on the right
  - Plus rotates 45deg into a cross while the row is open
  - First section starts open; any number of rows can be open at once
  - Body text keeps the alignment the description already had
  - A description with no headings is left untouched
*/
(function () {
  var ROOT_SELECTOR = [
    '.product-details rte-formatter.rte',
    '.product-details .text-block.rte',
    '.product-information rte-formatter.rte',
    '.product-information .text-block.rte'
  ].join(',');

  var HEADING = /^H[234]$/;

  var PLUS_SVG =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M10 3.75V16.25" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
    '<path d="M3.75 10H16.25" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
    '</svg>';

  function buildOne(root) {
    if (!root || root.dataset.tscAccordion === '1') return;

    var children = Array.prototype.slice.call(root.childNodes);
    var hasHeading = children.some(function (n) {
      return n.nodeType === 1 && HEADING.test(n.tagName);
    });
    if (!hasHeading) return;

    var intro = [];
    var groups = [];
    var current = null;

    children.forEach(function (node) {
      if (node.nodeType === 1 && HEADING.test(node.tagName)) {
        current = { heading: node, body: [] };
        groups.push(current);
      } else if (current) {
        current.body.push(node);
      } else {
        intro.push(node);
      }
    });

    if (!groups.length) return;

    var frag = document.createDocumentFragment();

    intro.forEach(function (node) {
      frag.appendChild(node);
    });

    groups.forEach(function (group, index) {
      var row = document.createElement('accordion-custom');
      row.className = 'tsc-desc-acc__row';

      var details = document.createElement('details');

      // accordion-custom re-applies the open state from these attributes when it
      // upgrades, so the first row has to declare them or it would be forced shut.
      if (index === 0) {
        row.setAttribute('open-by-default-on-desktop', '');
        row.setAttribute('open-by-default-on-mobile', '');
        details.setAttribute('open', '');
      }

      var summary = document.createElement('summary');
      summary.className = 'tsc-desc-acc__summary';

      var title = document.createElement('span');
      title.className = 'tsc-desc-acc__title';
      title.innerHTML = group.heading.innerHTML;
      summary.appendChild(title);

      var icon = document.createElement('span');
      icon.className = 'tsc-desc-acc__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = PLUS_SVG;
      summary.appendChild(icon);

      details.appendChild(summary);

      var content = document.createElement('div');
      content.className = 'details-content tsc-desc-acc__content';
      group.body.forEach(function (node) {
        content.appendChild(node);
      });
      details.appendChild(content);

      row.appendChild(details);
      frag.appendChild(row);
    });

    groups.forEach(function (group) {
      if (group.heading.parentNode) group.heading.parentNode.removeChild(group.heading);
    });

    root.dataset.tscAccordion = '1';
    root.classList.add('tsc-desc-acc');
    root.appendChild(frag);
  }

  function run(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    try {
      if (context.matches && context.matches(ROOT_SELECTOR)) buildOne(context);
      var roots = context.querySelectorAll(ROOT_SELECTOR);
      Array.prototype.forEach.call(roots, buildOne);
    } catch (e) {
      /* never let this break the page */
    }
  }

  function init() {
    run(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) run(added[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
